export default {
    paddingTop: '20px',
    paddingBottom: '24px',
    marginBottom: '32px',
};
